import { apiGet } from '@/store/api';
import { useDashboardStore } from '@/store/dashboardStore';

export async function fetchAgencyDashboards() {
  const result = await apiGet(`/dashboard/agency-dashboards`);
  useDashboardStore().setAgencyReports(result);
  return result;
}
